export default __webpack_public_path__ + "static/media/GuessingTimeRoundLoader.549c181f.webp";